import { getDateString } from '@/ui/utils/utils'

export const transformUsersIssues = (
    users: TAssetUser[]
): (TfdIssueRaw | TBECIssueRaw)[] => {
    return (users ?? [])
        .map((user) => {
            return user?.issues?.map((issue) => {
                if (issue.issue_type === 'FRAUD_DEFENSE') {
                    return createFdIssue(issue, user)
                } else if (issue.issue_type === 'INBOX_RULE') {
                    return createBecIssue(issue, user)
                }
            })
        })
        .flat()
        .filter(
            (issue): issue is TfdIssueRaw | TBECIssueRaw => issue !== undefined
        )
}

const createFdIssue = (
    issue: TFraudDefenseIssue,
    user: TAssetUser
): TfdIssueRaw => {
    return {
        id: issue.id,
        finding_id: issue.finding_id,
        asset: {
            asset_type: 'user',
            value: user.hostname,
            id: user.id,
            external_issue_id: issue.id,
        },
        email_data: {
            subject: issue.email_data.subject,
            to_recipients: issue.email_data.to_recipients,
            sender: issue.email_data.sender,
            date_sent: issue.email_data.date_sent,
            reasons: issue.email_data.reasons,
        },
        category: issue.issue_category,
        issue_type: 'FRAUD_DEFENSE',
        name: issue.name + ' - ' + getDateString(issue.email_data.date_sent),
        long_description: issue.long_description,
        short_description: issue.short_description,
        resolution_url: issue.resolution_url,
        severity: issue.severity as TIssueSeverity,
        severity_score: 0.6,
        status: issue?.status?.toLowerCase(),
    }
}

const createBecIssue = (issue: TBECIssue, user: TAssetUser): TBECIssueRaw => {
    return {
        id: issue.id,
        user_id: user.id,
        finding_id: issue.finding_id,
        asset: {
            asset_type: 'user',
            value: user.hostname,
            id: user.id,
            external_issue_id: issue.id,
        },
        hostname: user.hostname,
        rule_data: issue.rule_data,
        issue_category: issue.issue_category,
        issue_type: 'INBOX_RULE',
        name: issue.name + ' - ' + user.hostname,
        long_description: issue.long_description,
        short_description: issue.short_description,
        resolution_url: issue.resolution_url,
        severity: issue.severity as TIssueSeverity,
        severity_score: issue.severity_score,
        status: issue?.status?.toLowerCase() as TIssueStatus,
        created_at: issue.created_at,
    }
}
